/* eslint-disable react-refresh/only-export-components */
import * as React from "react";
import * as TogglePrimitive from "@radix-ui/react-toggle";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const toggleVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-md transition-colors hover:bg-muted hover:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "data-[state=off]:border data-[state=on]:bg-azure data-[state=on]:text-azure-foreground hover:bg-sky hover:text-accent-foreground",
        round:
          "rounded-full data-[state=off]:border-2 data-[state=on]:bg-azure data-[state=on]:text-azure-foreground hover:bg-sky hover:text-accent-foreground",
        round_dot:
          "rounded-full border-2 border-muted-foreground relative data-[state=on]:border-azure data-[state=on]:after:content-[''] data-[state=on]:after:absolute data-[state=on]:after:top-1/2 data-[state=on]:after:left-1/2 data-[state=on]:after:-translate-x-1/2 data-[state=on]:after:-translate-y-1/2 data-[state=on]:after:w-1/2 data-[state=on]:after:h-1/2 data-[state=on]:after:rounded-full data-[state=on]:after:bg-azure hover:bg-muted disabled:border-muted",
      },
      size: {
        default: "h-9 px-2 min-w-9",
        xs: "h-4 px-1 min-w-4",
        sm: "h-8 px-1.5 min-w-8",
        lg: "h-10 px-2.5 min-w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

const Toggle = React.forwardRef<
  React.ElementRef<typeof TogglePrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> &
    VariantProps<typeof toggleVariants>
>(({ className, variant, size, ...props }, ref) => (
  <TogglePrimitive.Root
    ref={ref}
    className={cn(toggleVariants({ variant, size, className }))}
    {...props}
  />
));

Toggle.displayName = TogglePrimitive.Root.displayName;

export { Toggle, toggleVariants };
